module.exports = require("core-js/library/fn/object/set-prototype-of");


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/core-js/object/set-prototype-of.js
 ** module id = 617
 ** module chunks = 0
 **/